import CardFrom, { CardFormConfig } from '../../component/card/card-from';
import TableComponent, { HeadCell } from '../../component/table/table.component';
import { ConditionType, SearchKeyInput, SearchKeyInputItems } from '../../component/form/search-key-input.component';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import { Box, Grid, InputAdornment, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import ISVRestaurantDetailDialog from './isv-fee-setting';
import ISVRestaurantDialog from './isv-restaurant-dialog';
import { Admin, Restaurant } from '../../models';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import _ from 'lodash';
import apiManage from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import { dateFormat } from '../../constants/utils';


export default function VivaWalletSettingPage() {
    // 原始用户信息
    const [userInfo, setUserInfo] = useState<Admin>({})
    // 编辑后的用户信息
    const [editUserInfo, setEditUserInfo] = useState<Pick<Admin, 'isv_client_id' | 'isv_client_secret' | 'isv_fee'>>({});
    // 表格数据
    const [list, setList] = useState<Restaurant[]>([])
    const [totalCount, setTotalCount] = useState(0)
    // 表格loading
    const [isLoading, setIsLoading] = useState(false)
    // 页码
    const [pagPage, setPagPage] = useState(1)
    const [pagPerPage, setPagPerPage] = useState(20)
    // 排序
    const [sortKey, setSortKey] = useState('')
    const [sortValue, setSortValue] = useState<0 | 1 | 2>(0)
    // 搜索
    const [conditions, setConditions] = useState<ConditionType[]>([]);

    // 编辑弹窗餐馆详情
    const [detail, setDetail] = useState({})
    // 编辑弹窗开关
    const [isOpenEditDialog, setIsOpenEditDialog] = useState(false)
    // 新增弹窗开关
    const [isOpenAddDialog, setIsOpenAddDialog] = useState(false)

    useEffect(() => {
        init()
    }, [])


    useEffect(() => {
        // 排序、分页改变时重新获取数据
        getData()
    }, [sortKey, sortValue, pagPage, pagPerPage, conditions])

    /**
     * 初始化
     */
    const init = () => {
        getUserInfo();
    }
    const getUserInfo = async () => {
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        const userInfo = await apiManage.get_admin_id_id(account._id || '');
        if (!userInfo?.error) {
            setUserInfo(userInfo);
            setEditUserInfo(_.pick(userInfo, ['isv_client_id', 'isv_client_secret', 'isv_fee']));
        }
    }


    /**
     * 获取数据
     */
    const getData = async () => {
        setIsLoading(true)
        // 搜索条件
        // eslint-disable-next-line prefer-const
        let searchObj = {}
        conditions.forEach((item) => {
            searchObj[item.key] = searchObj[item.key] ? _.concat(searchObj[item.key], item.value) : [item.value];
        })
        const result = await apiManage.get_related_isv_restaurants({
            join_isv: true,
            pag_per_page: pagPerPage,
            pag_page: pagPage,
            sort_key: (sortKey === '' || sortValue === 0) ? undefined : sortKey,
            sort_value: sortValue === 0 ? undefined : (sortValue === 1 ? -1 : 1),
            ...searchObj
        })
        // 请求成功
        if (result && !result.error) {
            setList(result?.[0]?.dbResults ?? [])
            setTotalCount(result?.[0]?.totalCount?.[0]?.count ?? 0)
        }
        setIsLoading(false)
    }

    /**
     * 表单回调
     * @param value
     * @param key
     */
    const onFormChange = (value: string, key: string) => {
        let newValue = value
        if (key === 'isv_fee') {
            newValue = value.slice(0, value.indexOf('.') + 3);
        }
        editUserInfo[key] = newValue
        setEditUserInfo({ ...editUserInfo })
    }


    /**
     * 保存表单
     */
    const onFormSave = async () => {
        const newAccount = {
            _id: userInfo._id,
            ...editUserInfo,
            isv_fee: Number(editUserInfo.isv_fee ?? 0)
        }
        const result = await apiManage.patch_admin_id_admin(newAccount)
        if (result && !result?.error) {
            GlobalNotification.success(`${i18n.t('dish_book_msg_save_success')}`);
            getUserInfo()
        } else {
            GlobalNotification.error(`${i18n.t('dish_book_msg_save_failed')}`);
        }
    }

    /**
     * 打开新增弹窗
     */
    const handleClickAdd = () => {
        setIsOpenAddDialog(true)
    }

    /**
     * 关闭新增弹窗
     */
    const handleCloseDialog = () => {
        setIsOpenAddDialog(false)
    }

    /**
     * 新增弹窗确定按钮
     */
    const handleConfirmDialog = () => {
        getData()
    }

    /**
     * 打开编辑弹窗
     */
    const handleClickEdit = (data: Restaurant) => {
        setIsOpenEditDialog(true)
        setDetail(data)
    }

    /**
     * 关闭编辑弹窗
     */
    const handleCloseEditDialog = () => {
        setIsOpenEditDialog(false)
    }

    /**
     * 编辑弹窗确定按钮
     */
    const handleConfirmEditDialog = () => {
        setIsOpenEditDialog(false)
        getData()
    }


    /**
     * 页码回调
     * @param params
     */
    const changePageCallback = (params: {
        page: number;
        curRowsPerPage: number;
    }) => {
        setPagPerPage(params.curRowsPerPage)
        setPagPage(params.page + 1)
    }

    /**
     * 搜索
     * @param conditions
     */
    const handleSearch = (conditions: ConditionType[]) => {
        setPagPage(1)
        setConditions([...conditions])
    }

    /**
     * 排序
     * @param headCell
     */
    const handleSort = (headCell: HeadCell) => {
        let newSortValue = sortValue;
        switch (headCell.sortStatus) {
            case 0: {
                newSortValue = 1;
                break;
            }
            case 1: {
                newSortValue = 2;
                break;
            }
            case 2: {
                newSortValue = 0;
                break;
            }
        }
        setSortKey(headCell.id)
        setSortValue(newSortValue)
    }




    // 表单
    const cardConfig: CardFormConfig[] = [{
        md: 12,
        columnSpacing: { xs: 2 },
        rowSpacing: 2,
        key: 'base_setting_title',
        title: i18n.t('base_setting_title'),
        actionRender: (
            <ButtonComponent
                action='SAVE'
                handleClick={() => onFormSave()}
                async={true}
            />
        ),
        children: [{
            key: 'isv_client_id',
            label: 'Viva Wallet Client ID',
            comType: 'INPUT',
            xs: 12,
            inputIsEdited: userInfo.isv_client_id !== editUserInfo.isv_client_id,
            onChange: (e) => onFormChange(e.target.value, 'isv_client_id')
        },
        {
            key: 'isv_client_secret',
            label: 'Viva Wallet Client secret',
            comType: 'INPUT',
            xs: 12,
            inputIsEdited: userInfo.isv_client_secret !== editUserInfo.isv_client_secret,
            onChange: (e) => onFormChange(e.target.value, 'isv_client_secret')
        },
        {
            key: 'isv_fee',
            label: 'viva_wallet_setting_page_text_isv_fee',
            comType: 'INPUT',
            xs: 12,
            contentType: 'number',
            inputProps: {
                min: 0,
                max: 100,
            },
            InputProps: {
                endAdornment: (< InputAdornment position='end'>%</InputAdornment>),
            },
            inputIsEdited: Number(userInfo.isv_fee ?? 0) !== Number(editUserInfo.isv_fee ?? 0),
            onChange: (e) => onFormChange(e.target.value, 'isv_fee')
        },]
    }]

    // 查找表格条件下拉框 静态数据
    const filterList: SearchKeyInputItems[] = [
        {
            value: 'nickname',
            label: i18n.t('operation_record_restaurant_nickname'),
            type: 'TEXT'
        }
    ];

    // 表格头部
    const tableHeadCell: HeadCell[] = [
        {
            id: 'nickname',
            label: i18n.t('restaurant_management_page_table_text_restaurant_name'),
            sortStatus: sortKey === 'nickname' ? sortValue : 0
        },
        {
            id: 'string_id',
            label: i18n.t('restaurant_page_input_text_restaurant_identification_code'),
            sortStatus: sortKey === 'string_id' ? sortValue : 0
        },
        {
            id: 'belonged_group',
            label: i18n.t('general_text_belonged_group'),
            sortStatus: sortKey === 'belonged_group' ? sortValue : 0,
            renderFunction: (row) => {
                return row?.belonged_group?.[0]?.nickname ?? ''
            }
        },
        {
            id: 'reg_city',
            sortStatus: sortKey === 'reg_city' ? sortValue : 0,
            label: i18n.t('restaurant_management_page_table_text_city'),
        },
        {
            id: 'isv_fee',
            label: i18n.t('viva_wallet_setting_page_text_isv_fee'),
            sortStatus: sortKey === 'isv_fee' ? sortValue : 0,
            renderFunction: (row) => {
                return `${row?.isv_fee ?? ''}%`
            }
        },
        {
            id: 'isv_connect_create',
            label: i18n.t('operation_record_operation_time'),
            sortStatus: sortKey === 'isv_connect_create' ? sortValue : 0,
            renderFunction: (row) => {
                return dateFormat(row.isv_connect_create, 'YYYY-MM-DD HH:mm')
            }
        },
        {
            id: 'operate',
            label: i18n.t('general_text_operating'),
            renderFunction: (row) => {
                return (<ButtonComponent action='VIEW' handleClick={() => handleClickEdit(row)} />)
            }
        }
    ]

    return (
        <>
            <Box sx={{ maxWidth: 700 }}>
                <CardFrom
                    config={cardConfig}
                    data={editUserInfo}
                />
            </Box>
            <Paper sx={{ padding: 4, marginTop: 4 }}>
                <Grid sx={{ mb: 3 }} container direction='row' alignItems='center' justifyContent='flex-start' spacing={2}>
                    <ButtonComponent action='ADD' handleClick={handleClickAdd} />
                    <Box sx={{ mt: 2 }}>
                        <SearchKeyInput
                            items={filterList}
                            conditions={conditions}
                            onSearch={handleSearch}
                            showConditionsBox
                        />
                    </Box>
                </Grid>
                <TableComponent
                    {...{
                        showChecked: 0,
                        list,
                        isUseCustomPagination: true,
                        headCellList: tableHeadCell,
                        isTableLoading: isLoading,
                        handleSort,
                        isPagination: true,
                        allCount: totalCount,
                        changePageCallback,
                        isCurrentPageData: true,
                        currentPage: pagPage - 1,
                    }}
                />
            </Paper>
            {
                isOpenAddDialog ?
                    <ISVRestaurantDialog
                        isOpen={isOpenAddDialog}
                        handleClose={handleCloseDialog}
                        handleConfirm={handleConfirmDialog}
                    />
                    :
                    null
            }
            <ISVRestaurantDetailDialog
                actionMode='EDIT'
                detail={[detail]}
                isOpen={isOpenEditDialog}
                handleClose={handleCloseEditDialog}
                handleConfirm={handleConfirmEditDialog}
            />
        </>
    )
}
